import { render } from "./terms.vue?vue&type=template&id=c3556d6a"
import script from "./terms.vue?vue&type=script&lang=js"
export * from "./terms.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__